const IconSearchFormDropdown = props => (
	<svg xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
		<path
			d="M12 6.66654C12 6.66654 9.05407 10.6665 8 10.6665C6.94587 10.6665 4 6.6665 4 6.6665"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

export default IconSearchFormDropdown;
